import { motion } from 'framer-motion';
import { sports } from '@/components/training/exerciseData';
import { cn } from '@/lib/utils';

export default function SportSelector({ value, onChange }) {
  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-slate-700">Select Your Sport</label>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {sports.map((sport, index) => (
          <motion.button
            key={sport.value}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.03 }}
            type="button"
            onClick={() => onChange(sport.value)}
            className={cn(
              'relative p-4 rounded-2xl border-2 transition-all duration-300',
              'hover:scale-[1.02] hover:shadow-lg',
              value === sport.value
                ? 'border-violet-500 bg-gradient-to-br from-violet-50 to-indigo-50 shadow-md'
                : 'border-slate-200 bg-white hover:border-slate-300',
            )}
          >
            {value === sport.value && (
              <motion.div
                layoutId="sportSelector"
                className="absolute inset-0 rounded-2xl bg-gradient-to-br from-violet-500/10 to-indigo-500/10"
                initial={false}
                transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
              />
            )}
            <div className="relative flex flex-col items-center gap-2">
              <span className="text-2xl">{sport.icon}</span>
              <span
                className={cn(
                  'text-sm font-medium transition-colors',
                  value === sport.value ? 'text-violet-700' : 'text-slate-600',
                )}
              >
                {sport.label}
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
